export function CenteredMessage({ text }) {
    return (
      <div style={{
        padding: '60px 40px',
        textAlign: 'center',
        color: '#9ca3af',
        backgroundColor: '#f9fafb',
        borderRadius: '12px',
        border: '2px dashed #e5e7eb'
      }}>
        <p style={{
          fontSize: '16px',
          margin: 0,
          fontWeight: '500'
        }}>
          {text}
        </p>
      </div>
    );
  }